import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { CREATE_AIRPORT_V2, CREATE_AIRPORT_V2_SUCCESS, CREATE_AIRPORT_V2_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* createAirportV2({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/benefit-type/airport-transfer/airports`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: CREATE_AIRPORT_V2_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: CREATE_AIRPORT_V2_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CREATE_AIRPORT_V2_ERROR, payload: error });
  }
}

export function* watchcreateAirportV2() {
  yield takeEvery(CREATE_AIRPORT_V2, createAirportV2);
}

function* createAirportV2Saga() {
  yield all([fork(watchcreateAirportV2)]);
}

export default createAirportV2Saga;
